// extracted by mini-css-extract-plugin
export var cardWrapper = "_44-0";